import { render, staticRenderFns } from "./CompletenessBanner.vue?vue&type=template&id=865f9ab4"
import script from "./CompletenessBanner.vue?vue&type=script&lang=ts"
export * from "./CompletenessBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports